import React, { useEffect } from "react";
import { Link } from "react-router-dom";

// Adds <meta name="robots" content="noindex, nofollow"> while mounted.
export function NoIndex() {
  useEffect(() => {
    let m = document.querySelector('meta[name="robots"]');
    const created = !m;
    if (!m) {
      m = document.createElement("meta");
      m.setAttribute("name", "robots");
      document.head.appendChild(m);
    }
    const prev = m.getAttribute("content");
    m.setAttribute("content", "noindex, nofollow");
    return () => {
      if (created) m.remove();
      else if (prev != null) m.setAttribute("content", prev);
      else m.removeAttribute("content");
    };
  }, []);
  return null;
}

export default function NotFound() {
  const btn = "px-4 py-2 border border-pslborder rounded-sm font-bold text-green hover:border-gold transition-colors";
  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center text-center" data-testid="not-found">
      <NoIndex />
      <div className="text-gold text-xs font-bold uppercase tracking-[0.25em] mb-2">404 — Page not found</div>
      <h1 className="font-head font-black text-3xl md:text-4xl text-green mb-3">That page isn't here</h1>
      <p className="text-ink/60 max-w-md mb-6">The page you were looking for has moved or no longer exists. Here's where to go next.</p>
      <div className="flex flex-wrap gap-3 justify-center">
        <Link to="/" className="px-4 py-2 bg-green text-cream rounded-sm font-bold hover:bg-ink transition-colors">Home</Link>
        <Link to="/news" className={btn}>News</Link>
        <Link to="/table" className={btn}>Table</Link>
        <Link to="/fixtures" className={btn}>Fixtures</Link>
        <Link to="/clubs" className={btn}>Clubs</Link>
        <Link to="/forum" className={btn}>Forum</Link>
      </div>
    </div>
  );
}
